import { useMutation, useQueryClient } from '@tanstack/react-query';

import { dealsBoardApi, dealsBoardQueryKeys } from '@crm/entities/deals-board';

export const useSortColumnMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: dealsBoardApi.sortDealColumn,
        onSettled: async () => {
            await queryClient.invalidateQueries({ queryKey: dealsBoardQueryKeys.board() });
        },
    });
};
